import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

// project-imports
import Loadable from 'components/Loadable';
import Error404 from 'pages/maintenance/error/404';
import Error500 from 'pages/maintenance/error/500';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/auth/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/auth/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/auth/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/auth/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/auth/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/auth/code-verification')));
const AuthPrivacyPolicy = Loadable(lazy(() => import('pages/auth/auth/privacy-policy')));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <Outlet />,
      children: [
        {
          path: '',
          element: <AuthLogin />
        },
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        },
        {
          path: 'privacy-policy',
          element: <AuthPrivacyPolicy />
        }
      ]
    },
    {
      path: 'maintenance/error/500',
      element: <Error500 />
    },
    {
      path: '*',
      element: <Error404 />
    }
  ]
};

export default LoginRoutes;
